class FuelSurchagesCreateController {
	/*@ngInject*/
	constructor(Auth, $state, User, FuelSurchargeService, Modal, $translate, UserService, BranchService, SetupService, $q, $scope) {
		this.Auth = Auth;
		this.Modal = Modal;
		this.User = User;
		this.$state = $state;
		this.FuelSurchargeService = FuelSurchargeService;
		this.UserService = UserService;
		this.BranchService = BranchService;
		this.SetupService = SetupService;
		this.$q = $q;
		this.$scope = $scope;
		this.$translate = $translate;
		this.permissions = this.Auth.permission();
		this.branchId = this.User.getUser().branchId;
		this.branchesList = [];
		this.appliedList = [
			{
				label: this.$translate.instant('fuel_surcharge.applied_monthly'),
				value: 'MONTHLY'
			},
			{
				label: this.$translate.instant('fuel_surcharge.applied_bi_weekly'),
				value: 'BI_WEEKLY'
			},
			{
				label: this.$translate.instant('fuel_surcharge.applied_weekly'),
				value: 'WEEKLY'
			},
		];
		this.localLang = {
			selectAll: this.$translate.instant('common.selectall'),
			selectNone: this.$translate.instant('common.selectnone'),
			reset: this.$translate.instant('shipmentBatch.reset'),
			search: this.$translate.instant('common.search'),
			nothingSelected: this.$translate.instant('common.noneselected'),         //default-label is deprecated and replaced with this.
		};

		this.defaultModel = {
			id: '',
			name: '',
			status: true,
			appliedRange: null,
			branchIds: [],
			branches: [],
			description: '',
			surcharges: [],
			customers: [],
			branchId: this.branchId
		}

		this.model = angular.copy(this.defaultModel)
	}

	$onInit() {
		if (!this.model.surcharges.length) {
			this.addNewSurcharge()
		}

		this.$q.all([
			this.BranchService.all(null, 0, 1000),
		])
			.then((data) => {
				this.branches = data[0].results
			})
			.catch((err) => {
				if (err.data && err.data.errors) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				} else {
					this.errorMessage = err.message || err;
				}
			})
	}
	setSurcharges() {
		this.model.surcharges.push({
			priceRange: {
				from: this.model.surcharges.length ? parseFloat(this.model.surcharges[this.model.surcharges.length - 1].priceRange.to) + 0.01 : 0.00,
				to: null
			},
			surcharge: ''
		})
	}
	addNewSurcharge() {
		if ( this.model.surcharges.length ) {
			let currentIndex = this.model.surcharges[this.model.surcharges.length - 1];
			if (currentIndex.priceRange.to) {
				this.setSurcharges();
			}
		} else {
			this.setSurcharges();
		}
	}

	isSurchargeValid() {
		if (this.model.surcharges.length) {
			let invalidList = this.model.surcharges.filter((item) => (!item.priceRange.to) || (!item.priceRange.to) || (!item.surcharge))
			return invalidList && invalidList.length ? false : true;
		} else {
			return false;
		}
	}

	onSurchargeChange(e, i) {
		if (this.model.surcharges && this.model.surcharges.length) {
			this.model.surcharges.forEach((ele, index) => {
				if (this.model.surcharges[index + 1] && (!this.model.surcharges[index + 1].priceRange.from || this.model.surcharges[index].priceRange.to > this.model.surcharges[index + 1].priceRange.from)) {
					this.model.surcharges[index + 1].priceRange.from = parseFloat(this.model.surcharges[index].priceRange.to) + 0.01
				}
			})
		}
	}
	
	removeSurcharge(index) {
		this.model.surcharges.splice(index, 1)
	}
	removeCustomer(index) {
		this.model.customers.splice(index, 1)
	}
	addNewCustomer() {
		this.Modal.FuelSurchargeCustomer({}, ({ customer, modal }) => {
			modal.close()
			this.model.customers.push(customer)
			this.model.customers = _.uniqBy(this.model.customers, 'id')
		}, ({ modal }) => {
			this.isLoading = false;
			if (modal) modal.close();
		});
	}

	ngPercentage(index) {
		if (this.model.surcharges[index].surcharge) {
			let str = this.model.surcharges[index].surcharge.toString();
			return this.model.surcharges[index].surcharge = str ? str.endsWith('%') ? str : str + '%' : null;
		}
	}
	removePrecentageSign(index) {
		if (this.model.surcharges[index].surcharge && this.model.surcharges[index].surcharge.length) {
			let str = this.model.surcharges[index].surcharge || '';
			return this.model.surcharges[index].surcharge = str.endsWith('%') ? str.replace('%', '') : str;
		}
	}

	askCreate() {

		this.Modal.confirm({
			header: this.$translate.instant('item.create_another_title'),
			message: this.$translate.instant('item.create_another_message'),
			callback: ({
				modal,
				$scope
			}) => {
				this.reset()
				modal.close()
			},
			negative: ({
				modal,
				$scope
			}) => {
				modal.close()
				window.history.go(-1)
			},
			type: 'primary',
			buttons: ['common.yes', 'common.no']
		})
	}
	submit() {
		this.errorMessage = '';
		let newFuelSurcharge = Object.assign({}, this.model)
		if (newFuelSurcharge.branchIds && newFuelSurcharge.branchIds.length) {
			newFuelSurcharge
				.branches = newFuelSurcharge.branchIds.map(branchObj => branchObj.id).join(",")
		}
		if (newFuelSurcharge.surcharges && newFuelSurcharge.surcharges.length) {
			newFuelSurcharge.surcharges.map(surchargeObj => {
				let str = surchargeObj.surcharge;
				return surchargeObj.surcharge = str.endsWith('%') ? str.replace('%', '') : str;
			})
		}
		newFuelSurcharge = _.pick(newFuelSurcharge, Object.keys(this.defaultModel))
		this.loading = true
		this.FuelSurchargeService.create(newFuelSurcharge)
			.then((data) => {
				this.askCreate()
				this.loading = false
			})
			.catch((err) => {
				this.loading = false;
				if (err.data && err.data.errors && err.data.errors.length) {
					err.data.errors.map((e) => {
						this.errorMessage += e.message + '<br/>'
					})
				} else {
					this.errorMessage = err.data.message ? err.data.message : err;
				}
			})
	}


	// addMultipleBranchs() {
	// 	const branches = this.model.branchIds.map((b) => b.id)
	// 	return new Promise((resolve, reject) => {
	// 		this.UserService.createBranchGrouped({ userId: this.model.id, branches: branches })
	// 			.then(() => {
	// 				resolve();
	// 			})
	// 			.catch((err) => {
	// 				reject(err);
	// 			});
	// 	})
	// }

	autoSelectSameForAll() {
		if (this.model.branchIds.length > 1) return this.model.sameForAll = true;
		else return this.model.sameForAll = false;
	}

	removeSelection() {
		this.model.sameForAll = false;
	}

	resetMultiBranchSelection() {
		if (this.model.branchIds && this.model.branchIds.length) {
			this.model.branchIds.forEach((selectedBranch) => {
				this.branches.filter((branch) => {
					if (branch.branchId == selectedBranch.branchId) {
						branch.ticked = false;
					}
				})
			})
		}
	}
	reset() {
		this.resetMultiBranchSelection()
		this.model = {
			id: '',
			name: '',
			status: true,
			appliedRange: '',
			branchIds: [],
			branches: [],
			description: '',
			surcharges: [],
			customers: [],
		};
		this.addNewSurcharge()
	}

	goToCustomer = (customerId) => {
		this.$state.go('customer.edit', ({
			id: customerId
		}))
	}

	showLocations(customerId) {
		this.Modal.FuelSurchargeLocations(this.model, customerId, ({ modal }) => {
			modal.close()
		}, ({ modal }) => {
			if (modal) modal.close();
		});
	}

}

export default FuelSurchagesCreateController;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/fuel_surcharges/create/fuel_surcharges.create.controller.js